import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "options", "value", "placeholder", "label", "theme", "variant", "hasOutline", "isError", "isValid", "tooltipText", "hasOptionGroups", "childNodesValues", "children"];
import React from 'react';
import classNames from 'classnames';
import Tooltip from '@ratedpeople/tooltip';
import style from './style.module.css';
var defaultProps = {
  theme: 'default',
  variant: 'default',
  hasOutline: false,
  tooltipText: '',
  hasOptionGroups: false,
  placeholder: 'Please select',
  childNodesValues: []
};

function Select(props) {
  var _classNames, _classNames2, _classNames3, _classNames4, _classNames5, _classNames6, _classNames7, _classNames8;

  var className = props.className,
      options = props.options,
      value = props.value,
      placeholder = props.placeholder,
      label = props.label,
      theme = props.theme,
      variant = props.variant,
      hasOutline = props.hasOutline,
      isError = props.isError,
      isValid = props.isValid,
      tooltipText = props.tooltipText,
      hasOptionGroups = props.hasOptionGroups,
      childNodesValues = props.childNodesValues,
      children = props.children,
      attr = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, style.container, (_classNames = {}, _classNames[style.containerSlim] = variant === 'slim', _classNames))
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(style.wrapper, (_classNames2 = {}, _classNames2[style.wrapperMaterial] = theme === 'material', _classNames2), (_classNames3 = {}, _classNames3[style.wrapperMaterialValid] = isValid, _classNames3))
  }, Boolean(label && value) && /*#__PURE__*/React.createElement("label", {
    className: style.label
  }, label), /*#__PURE__*/React.createElement("select", _extends({
    value: value,
    className: classNames(style.select, (_classNames4 = {}, _classNames4[style.error] = isError, _classNames4), (_classNames5 = {}, _classNames5[style.multiple] = attr.multiple || attr.size, _classNames5), (_classNames6 = {}, _classNames6[style.valid] = isValid, _classNames6), (_classNames7 = {}, _classNames7[style.selectLabel] = label && value, _classNames7), (_classNames8 = {}, _classNames8[style.outline] = value && hasOutline, _classNames8), style[theme])
  }, attr), Boolean(placeholder) && /*#__PURE__*/React.createElement("option", {
    disabled: true,
    value: ""
  }, placeholder), !hasOptionGroups && options && Boolean(options.length) && options.map(function (option) {
    return /*#__PURE__*/React.createElement("option", {
      key: option.labelText + "-" + option.value,
      value: option.value
    }, option.labelText);
  }), hasOptionGroups && options && options.map(function (option) {
    return /*#__PURE__*/React.createElement("optgroup", {
      key: option.labelText,
      label: option.labelText
    }, option.value.map(function (item) {
      return /*#__PURE__*/React.createElement("option", {
        key: item.labelText + "-" + item.value,
        value: item.value
      }, item.labelText);
    }));
  }))), tooltipText && /*#__PURE__*/React.createElement("div", {
    className: style.tooltipContainer
  }, /*#__PURE__*/React.createElement(Tooltip, {
    className: style.tooltip,
    tooltipText: tooltipText
  })), childNodesValues.includes(value) && /*#__PURE__*/React.createElement(React.Fragment, null, children));
}

Select.defaultProps = defaultProps;
export default Select;